import React, { useEffect, useState } from 'react';

const NoticeBoard = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch notices from Backend
  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/notices`);
        if (response.ok) {
          const data = await response.json();
          setNotices(data);
        }
      } catch (error) {
        console.error("Error fetching notices:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  if (loading) return null; // Hide completely while loading
  if (notices.length === 0) return null; // Hide if no notices exist

  return (
    <div className="container my-5">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-success text-white d-flex align-items-center">
          <i className="bi bi-megaphone-fill me-2"></i>
          <h5 className="mb-0">Notice Board</h5>
        </div>
        <div className="list-group list-group-flush">
          {notices.map((notice) => (
            <div key={notice._id} className="list-group-item py-3">
              <div className="d-flex w-100 justify-content-between align-items-center">
                <h6 className={`mb-1 fw-bold ${notice.type === 'Urgent' ? 'text-danger' : 'text-dark'}`}>
                  {notice.type === 'Urgent' && <span className="badge bg-danger me-2">URGENT</span>}
                  {notice.title}
                </h6>
                <small className="text-muted">
                  {new Date(notice.createdAt).toLocaleDateString()}
                </small>
              </div>
              <p className="mb-1 text-secondary small">{notice.message}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoticeBoard;